import React from 'react'
import {Input} from '../../../components/Input/Input'
import {MyTooltip} from '../../../components/ToolTip/ToolTip'

interface TitleFreePriceInputProps {
  value: string | null
  onChange: (value: string | null) => void
  disabled?: boolean
  required?: boolean
  alarm?: boolean
  alarmText?: string
  label?: string
  placeholder?: string
  marginTop?: string
  maxCaracteres?: number
  toolTip?: boolean
  toolTiptext?: string
  toolTipIcon?: string
  toolTipLink?: string
}

export const TitleFreePriceInput: React.FC<TitleFreePriceInputProps> = ({
  value,
  onChange,
  disabled = false,
  required = false,
  alarm = false,
  alarmText,
  label = 'Título',
  placeholder = 'Digite o título...',
  marginTop,
  maxCaracteres = 255,
  toolTip,
  toolTiptext,
  toolTipIcon,
  toolTipLink,
}) => {
  const handleChange = (newValue: string) => {
    onChange(newValue === '' ? null : newValue)
  }

  return (
    <Input
      inputAttr={{type: 'text'}}
      label={label}
      value={value || ''}
      change={handleChange}
      disabled={disabled}
      required={required}
      alarm={alarm}
      alarmText={alarmText}
      placeholder={placeholder}
      maxCaracteres={maxCaracteres}
      marginTop={marginTop}
      toolTip={toolTip}
      toolTiptext={toolTiptext}
      toolTipIcon={toolTipIcon}
      toolTipLink={toolTipLink}
    />
  )
}
